<script lang="ts" setup>
export interface AccordionController {
  isActive: (index: number) => boolean
  toggle: (index: number) => void
}

const props = defineProps<{
  activeIndex?: number
  multiple?: boolean
}>()

const activeIndices = ref<number[]>(
  props.activeIndex !== undefined && props.activeIndex >= 0 ? [props.activeIndex] : [],
)

const isActive = (index: number) => activeIndices.value.includes(index)

const toggle = (index: number) => {
  if (isActive(index)) {
    activeIndices.value = activeIndices.value.filter((activeIndex) => activeIndex !== index)
  } else {
    activeIndices.value = props.multiple ? [...activeIndices.value, index] : [index]
  }
}

provide<AccordionController>('accordion', { isActive, toggle })
</script>

<template>
  <ul class="accordion cul">
    <slot />
  </ul>
</template>
